import { css } from '@emotion/react';
import { genAIGradientType1, genAIGradientType2, gray1, gray3, primary, white } from 'styles/global_defaults/colors';
import { boldFontWeight, headerLineHeight, semiBoldFontWeight, textLargeBodyFontSize, textSmallFontSize } from 'styles/global_defaults/fonts';
import { halfSpacing, quarterSpacing, standardSpacing, threeQuartersSpacing } from 'styles/global_defaults/scaffolding';

const aiAssignmentFeedbackStyles = css`
  padding: ${standardSpacing}px ${standardSpacing * 2}px;
  background: ${genAIGradientType2};
  line-height: ${headerLineHeight}px;
  margin-right: -${standardSpacing}px;
  margin-left: -${standardSpacing}px;

  .ai-container {
    margin: auto;
    max-width: 800px;
  }

  .feedback-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${standardSpacing}px;

    .feedback-title {
      display: flex;
      align-items: center;
      gap: ${halfSpacing}px;
    }

    .ai-label {
      font-weight: ${boldFontWeight};
      font-size: ${textLargeBodyFontSize}px;
    }

    .visibility-tag {
      padding: 0 ${halfSpacing}px;
      background: ${genAIGradientType1};
      font-size: ${textSmallFontSize}px;
      font-weight: ${semiBoldFontWeight};
      color: ${gray1};
      border-radius: ${quarterSpacing}px;
    }
  }

  .feedback-section {
    margin-bottom: ${standardSpacing}px;

    .section-label {
      font-weight: ${boldFontWeight};
    }

    .ai-generating {
      color: ${gray3};
    }

    .feedback-actions {
      display: flex;
      gap: ${halfSpacing}px;
      margin-bottom: ${halfSpacing}px;
      align-items: center;

      .copy-button {
        padding: 0;
        display: flex;
        gap: ${quarterSpacing}px;
        align-items: center;
      }
    }

    .section-description {
      border: 1px dashed ${gray3};
      background: ${white};
      padding: ${threeQuartersSpacing}px;
      border-radius: ${halfSpacing}px;
    }
  }
`;

export default aiAssignmentFeedbackStyles;
